import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';
import { UserService } from '../../../user/user.service';
import { ProfileEpWizardDataDTO } from '../../../../dto/educational-path/profile-ep-wizard.dto';

function resolveProfileUserUuid(
  params: LoadDataParams | undefined,
  userService: UserService
): string | null {
  let userUuid = params?.queryParams?.['userUuid'];
  if (userUuid) {
    return userUuid;
  }

  const currentUrl = window.location.pathname;
  const profileMatch = currentUrl.match(/\/profile\/([a-f0-9-]{36})/);
  if (profileMatch) {
    return profileMatch[1];
  }

  userUuid = userService.getCurrentUserUuid();
  return userUuid ?? null;
}

export function profile_user_ep_wizard(
  _componentDataSourceService: ComponentDataSourceService,
  http: HttpClient,
  _router: Router,
  userService: UserService
) {
  const fetchWizardData = (userUuid: string) => {
    return http
      .get<ProfileEpWizardDataDTO>(
        `${environment.apiUrl}/users/${userUuid}/educational-paths/wizard`,
        { withCredentials: true }
      )
      .pipe(
        map((response: ProfileEpWizardDataDTO & { data?: ProfileEpWizardDataDTO }) => {
          const data = response?.data ?? response;
          return {
            user_uuid: data?.user_uuid ?? userUuid,
            default_dates: data?.default_dates ?? {
              requirement_started_at: '2023-01-01',
              maintenance_started_at: '2023-01-01',
            },
            paths: Array.isArray(data?.paths) ? data.paths : [],
            assignments: Array.isArray(data?.assignments) ? data.assignments : [],
          } as ProfileEpWizardDataDTO;
        }),
        catchError((error) => {
          console.error('Error loading profile EP wizard data:', error);
          return of({
            user_uuid: userUuid,
            default_dates: {
              requirement_started_at: '2023-01-01',
              maintenance_started_at: '2023-01-01',
            },
            paths: [],
            assignments: [],
          } as ProfileEpWizardDataDTO);
        })
      );
  };

  return {
    name: 'Profile EP Wizard',
    description: 'Data til bulk-tilknytning af uddannelsesveje på brugerprofil',
    execute: (params?: LoadDataParams) => {
      const userUuid = resolveProfileUserUuid(params, userService);
      if (userUuid) {
        return fetchWizardData(userUuid);
      }

      return userService.getCurrentUserFromToken().pipe(
        switchMap((currentUser) => {
          if (!currentUser?.uuid) {
            return of({
              user_uuid: '',
              default_dates: {
                requirement_started_at: '2023-01-01',
                maintenance_started_at: '2023-01-01',
              },
              paths: [],
              assignments: [],
            } as ProfileEpWizardDataDTO);
          }
          return fetchWizardData(currentUser.uuid);
        }),
        catchError(() =>
          of({
            user_uuid: '',
            default_dates: {
              requirement_started_at: '2023-01-01',
              maintenance_started_at: '2023-01-01',
            },
            paths: [],
            assignments: [],
          } as ProfileEpWizardDataDTO)
        )
      );
    },
  };
}
